import { render, staticRenderFns } from "./RightDrawer.vue?vue&type=template&id=273cd64a&scoped=true"
import script from "./RightDrawer.vue?vue&type=script&lang=js"
export * from "./RightDrawer.vue?vue&type=script&lang=js"
import style0 from "./RightDrawer.vue?vue&type=style&index=0&id=273cd64a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273cd64a",
  null
  
)

export default component.exports